import { UIcon } from "../common/ui.icon";

export function WCodexIcon(props) {
    const { name, size } = props;
    var cname = 'default';
    if (name) {
        cname = name
            .toLowerCase()
            .replaceAll(" ", "")
            .replaceAll("'", "")
    }

    return <UIcon
        altSrc={"codex/default"}
        size={size || 36}
        name={"codex/" + cname} />
}